import React from "react";
import { Instagram, Facebook, ExternalLink } from "lucide-react";
import { useContent } from "../context/ContentContext";

const OTA = [
  { key: "airbnb", label: "Airbnb", cls: "bg-[#FF5A5F]/10 text-[#e0484d] hover:bg-[#FF5A5F]/20" },
  { key: "booking", label: "Booking.com", cls: "bg-[#003580]/10 text-[#003580] hover:bg-[#003580]/20" },
  { key: "expedia", label: "Expedia", cls: "bg-[#00355F]/10 text-[#00355F] hover:bg-[#00355F]/20" },
  { key: "vrbo", label: "Vrbo", cls: "bg-[#245abc]/10 text-[#245abc] hover:bg-[#245abc]/20" },
];

export default function ExternalLinks({ className = "", label = "Also available on" }) {
  const { content } = useContent();
  const l = content?.external_links || {};
  const otas = OTA.filter((o) => l[o.key]);
  const socials = [["instagram", Instagram], ["facebook", Facebook]].filter(([k]) => l[k]);
  if (!otas.length && !socials.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="external-links">
      {label && otas.length > 0 && <span className="text-xs text-stone-400 mr-1">{label}</span>}
      {otas.map((o) => (
        <a key={o.key} href={l[o.key]} target="_blank" rel="noopener noreferrer" data-testid={`extbtn-${o.key}`}
          className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${o.cls}`}>
          {o.label} <ExternalLink size={12} />
        </a>
      ))}
      {socials.map(([k, Icon]) => (
        <a key={k} href={l[k]} target="_blank" rel="noopener noreferrer" data-testid={`extbtn-${k}`} aria-label={k}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-forest/5 text-forest hover:bg-forest/10 transition-colors">
          <Icon size={15} />
        </a>
      ))}
    </div>
  );
}
